import MainSectors from '../../elements/Sections/MainSectors/MainSectors';
import Main from '../../elements/Sections/Main/Main';
import PagesGrid from '../../elements/Sections/PagesGrid/PagesGrid';
import HomeArticles from '../../elements/Sections/Templates/HomeArticles';
import SliderPartners from '../../elements/SliderPartners/SliderPartners';
import SubscribeModal from '../../elements/SubscribeModal/SubscribeModal';
import { useEffect, useState } from 'react';
import { ActivityStrapi } from '../../../shared/interfaces';

function HomeV2() {
  const [activities, setActivities] = useState<ActivityStrapi[]>([]);

  useEffect(() => {
    fetch(
    `https://strapi-production-a706.up.railway.app/api/activities?filters[isGeneral][$eq]=true&populate=images&populate=activity_categories&populate=mainImage`
    )
      .then((res) => res.json())
      .then((data) => setActivities(data.data))
      .catch((err) => console.error('Failed to fetch acitivies:', err));
  }, []);

  return (
    <div className="page-home">
      <Main />
      <MainSectors />
      <PagesGrid activityList={activities} />
      <SliderPartners />
      <HomeArticles />
      <SubscribeModal />
    </div>
  );
}

export default HomeV2;
